import {type BackendOptions} from 'i18next-xhr-backend';
import {DEFAULT_I18N_LOCALE, I18N_SUPPORTED_LANGUAGES} from './constants';

/**
 * i18next backend options
 */
export const backendOptions: BackendOptions = {
	allowMultiLoading: false,
	loadPath: (lngs) => {
		const lng = I18N_SUPPORTED_LANGUAGES.includes(lngs[0]) ? lngs[0] : DEFAULT_I18N_LOCALE;
		return `/locales/${lng}/locales`;
	},
};

export default backendOptions;
